import React from 'react';
import { useParams } from 'react-router-dom';
import BannerSectionStyle7 from '../Section/BannerSection/BannerSectionStyle7';
import Section from '../Section';
import AppointmentSection from '../Section/AppointmentSection';
import BreadcrumbStyle2 from '../Breadcrumb/BreadcrumbStyle2';
import AboutSectionStyle2 from '../Section/AboutSection/AboutSectionStyle2';
import FeaturesSectionStyle3 from '../Section/FeaturesSection/FeaturesSectionStyle3';
import { pageTitle } from '../../helpers/PageTitle';

const testData = {
    ultrasound: {
        title: 'Ultrasound',
        description: 'Ultrasound is a safe, painless, and non-invasive imaging test that uses sound waves to view internal organs, soft tissues, and pregnancy-related development. At BRR Diagnostics, ultrasound scans help doctors examine abdominal organs, monitor fetal growth, and assess various medical conditions accurately and comfortably',
        keyPoints: [
            'Safe imaging with no radiation exposure',
            'Useful for pregnancy monitoring and organ evaluation'
        ],
        imgUrl: '/images/departments/ultrasound page.png',
        testNames: [
            'Whole Abdomen Scan',
            'Ultra Sound Pelvis Scan',
            'Early Pregnancy Scan',
            'Nuchal Translucency Scan',
            'Anamoly Scan',
            'Growth Scan',
            'Fetal Doppler Scan',
            'Follicular Study',
            'Ultrasound Neck',
            'Ultrasound KUB',
            'Sonomammography',
            'Scrotum Scan',
            'USG Soft Tissues',
            'NSG',
            'Carotid Doppler',
            'Limb Arterial Doppler',
            'Limb Venous Doppler',
        ],
    },
    'digital-x-ray': {
        title: 'Digital X-Ray',
        description:
            'Digital X-Ray provides quick and clear images of bones, chest, and internal structures using minimal radiation. At BRR Diagnostics, modern digital machines ensure faster scans, reduced radiation exposure, and high-quality images for accurate diagnosis.',
        keyPoints: [
            'Low radiation with instant digital reports',
            'Ideal for bones, chest, joints, and injuries'
        ],
        imgUrl: '/images/departments/x ray page.png',
        testNames: [
            'Chest X-Ray',
            'Elbow X-Ray',
            'Skull X-Ray',
            'Abdomen X-Ray',
            'Pelvis X-Ray',
            'Mandible X-Ray',
            'Forearm X-Ray',
            'Lumbosacral X-Ray',
            'Cervical X-Ray',
            'Foot X-Ray',
            'Shoulder X-Ray',
            'Hip X-Ray',
            'Knee X-Ray',
            'Ankle X-Ray',
        ],
    },
    hemotology: {
        title: 'Hematology',
        description:
            'Hematology tests evaluate blood health by measuring hemoglobin, platelets, white blood cells, and infection indicators. These tests help doctors diagnose conditions such as anemia, infections, fever, weakness, and blood-related disorders.',
        keyPoints: [
            'Helps detect anemia, infections, and blood disorders',
            'Essential for overall health assessment'
        ],
        imgUrl: '/images/departments/hematology page.png',
        testNames: [
            'CBC + Diff Count + Peripheral Smear',
            'Hemoglobin',
            'Total Leucocyte Count',
            'Platelet Count',
            'ESR',
            'Bloodgrouping & Rhtyping',
            'BT & CT',
            'Absolute Eosinophil Count',
        ],
    },
    'blood-profiles': {
        title: 'Blood Profiles',
        description:
            'Blood profile tests provide a complete overview of your health in a single report by checking sugar levels, cholesterol, liver, kidney, and heart function. These profiles help detect health risks early and support preventive care.',
        keyPoints: [
            'Multiple health parameters checked together',
            'Helps in early detection and prevention'
        ],
        imgUrl: '/images/departments/blood profiles page.png',
        testNames: [
            'Lipid Profile: HDL, LDL, Triglycerides, Cholesterol',
            'Diabetic Profile: FBS, PPBS, RBS, HbA1C, OGTT',
            'Kidney Function Test: Creatinine, Urea, eGFR, Electrolytes',
            'Iron Profile: Serum Iron, Ferritin, Total Iron Binding Capacity (TIBC)',
            'Liver Function Test: SGOT, SGPT, Alkaline Phosphatase, GGT, Albumin, Total Protien, Bilirubin T&D, Serum Amylase, Serum Lipase',

        ],
    },
    'clinical-pathology': {
        title: 'Clinical Pathology',
        description:
            'Clinical pathology includes routine tests such as urine, stool, pregnancy, and semen analysis to identify everyday health problems. These tests play an important role in detecting infections, kidney issues, sugar problems, and digestive disorders early.',
        keyPoints: [
            'Useful for routine and preventive testing',
            'Helps detect common health issues early'
        ],
        imgUrl: '/images/departments/clinical pathology page.png',
        testNames: [
            'Complete Urine Analysis',
            'Stool Analysis',
            'Urine Pregnancy Test',
            'Semen Analysis',
            'Urine Ketone Bodies',
            'Urine Albumin',
        ],
    },
    serology: {
        title: 'Serology',
        description:
            'Serology tests detect infections and immune-related conditions through blood analysis. At BRR Diagnostics, serology helps identify diseases such as dengue, typhoid, hepatitis, HIV, and other infections at the right time.',
        keyPoints: [
            'Early detection of infectious diseases',
            'Helps start timely and effective treatment'
        ],
        imgUrl: '/images/departments/serology page.png',
        testNames: [
            'Widal Test / Typhoid Test',
            'RA Factor',
            'ASO titre',
            'HIV Screening ( HIV-1 & HIV 2 )',
            'Hbs Ag',
            'HCV',
            'VDRL / Syphilis Test / RPR Test',
            'Dengue ( NS1 Antigen / IgM / IgG Antibodies )',
            'Malaria PV/PF',
            'CRP / Hs CRP',
        ],
    },
    'surgical-profiles': {
        title: 'Surgical Profiles',
        description:
            'Surgical profile tests are performed before surgery to assess blood health, organ function, clotting ability, and infection status. These tests ensure the patient is medically fit and reduce surgical risks.',
        keyPoints: [
            'Ensures safety before surgery',
            'Checks blood, organ function, and clotting'
        ],
        imgUrl: '/images/departments/surgical profiles page.png',
        testNames: [
            'Blood group & Rh typing',
            'Blood sugar (FBS / RBS)',
            'Liver function tests',
            'Electrolytes',
            'Kidney function tests: urea, creatinine',
            'Complete Blood Count (CBC): Platelets',
            'Coagulation profile: BT / CT (Bleeding Time / Clotting Time), PT / INR, APTT',
            'Urine examination: Routine urine analysis',
            'Infection screening: HIV, HBsAg (Hepatitis B)',
        ],
    },
    'antenatal-profiles': {
        title: 'Antenatal Profiles',
        description:
            'Antenatal profile tests monitor the health of both mother and baby during pregnancy. These tests help detect anemia, infections, blood sugar issues, and hormonal changes to ensure a safe pregnancy journey.',
        keyPoints: [
            'Supports healthy pregnancy care',
            'Monitors mother and baby’s health'
        ],
        imgUrl: '/images/departments/antenatal profiles page.png',
        testNames: [
            'Thyroid Function: TSH',
            'Urine Tests: Routine urine examination',
            'Blood Tests: Blood group & Rh typing, Hemoglobin (Hb) / Complete Blood Count (CBC), Blood sugar (FBS / RBS), VDRL (syphilis screening), HIV, HBsAg (Hepatitis B)',
        ],
    },
    hormones: {
        title: 'Hormones',
        description:
            'Hormone testing evaluates the body’s internal balance that controls metabolism, growth, fertility, and energy levels. Tests like thyroid and reproductive hormones help diagnose issues such as weight changes, infertility, tiredness, and menstrual irregularities.',
        keyPoints: [
            'Helps detect hormonal imbalances early',
            'Supports fertility, thyroid, and metabolic health'
        ],
        imgUrl: '/images/departments/hormones page.png',
        testNames: [
            'Cardiac Profile: NT Pro BNP - 2, High Sensitive Troponin I, Myoglobin, CK - MB.',
            'Venous Thromboembolism / Coagulation: D - Dimer Exclusion, Protien C, VWF ( Von Wille Brand Factor)',
            'Thyroid: TSH, T3, T4, FT4, FT3, Anti - Thyroglobin, Anti - TPO,',
            'Fertility: HCG, LH, FSH, Prolactin, AMH, Estradiol, Progesterone, Testesterone, Costisol - S',
            'Tumor Markers: TPSA, FPSA, AFP, CA 15-3, CA 19-9, CA - 125',
            'Bone & Mineral Metabolism: PTH (1-84), 25 OH Vit D Total, Vit B12, Folate, Ferritin, B2 Microglobulin',
            'Vector Brone Diseases: Dengue NSI, Dengue IgM, Dengue, IgG, Chikungunya IgG, Chikungunya IgM',
            'Hepatitis: HAV IgM, Anti HAV Total, HBsAG Ultra, Anti - HBs Total, Anti - HBC Total, HBC IgM, HBe/Anti HBe, Anti HCV, Anti HEV IgG, Anti HEV IgM, HIV Duo ULTRA',
            'TORC: TOXO IgM, TOXO IgG, CMV IgG, CMV IgM, RUB IgM, RUB IgG',
            'Brahms Procalcitonin',
            'Total IgE',
        ],
    },
};

export default function TestDetails() {
    const { testId } = useParams();
    const test = testData[testId];

    if (!test) {
        pageTitle('Test Not Found');
        return (
            <>
                <BreadcrumbStyle2 />
                <Section topMd={135} topLg={100} topXl={100}>
                    <div className="container">
                        <h2>Test Not Found</h2>
                        <p>The requested test details could not be found.</p>
                    </div>
                </Section>
            </>
        );
    }

    pageTitle(test.title);
    return (
        <>
            <BreadcrumbStyle2 />
            <Section topMd={135} topLg={100} topXl={100}>
                <AboutSectionStyle2
                    title={<span style={{ color: '#752d45' }}>{test.title}</span>}
                    subTitle={test.description}
                    imgUrl={test.imgUrl}
                />
                {test.keyPoints && test.keyPoints.length > 0 && (
                    <div className="container" style={{ marginTop: '20px' }}>
                        <h4 style={{ marginBottom: '15px', color: '#752d45' }}>Key Points:</h4>
                        <ul style={{ paddingLeft: '20px' }}>
                            {test.keyPoints.map((point, index) => (
                                <li key={index} style={{ marginBottom: '8px', fontSize: '16px', color: '#555' }}>
                                    {point}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </Section>

            <Section topMd={170} topLg={145} topXl={90}>
                {test.testNames ? (
                    <div className="container">
                        <div className="cs_section_heading cs_style_1 text-center">
                            <p className="cs_section_subtitle cs_accent_color cs_semibold text-uppercase">WHAT WE OFFER</p>
                            <h2 className="cs_section_title cs_fs_72 m-0">Tests Available</h2>
                        </div>
                        <div style={{ marginTop: '40px' }}>
                            <div className="row">
                                {test.testNames.map((name, index) => {
                                    const parts = name.split(':');
                                    const hasLabel = parts.length > 1;
                                    return (
                                        <div key={index} className="col-lg-3 col-md-4 col-sm-6" style={{ marginBottom: '15px' }}>
                                            <div style={{
                                                padding: '12px 15px',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '8px',
                                                borderLeft: '3px solid #752d45',
                                                fontSize: '15px',
                                                color: '#274760'
                                            }}>
                                                {hasLabel ? (
                                                    <>
                                                        <strong>{parts[0]}:</strong>{parts.slice(1).join(':')}
                                                    </>
                                                ) : (
                                                    name
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                ) : (
                    <FeaturesSectionStyle3
                        sectionTitle="Tests Available"
                        sectionTitleUp="WHAT WE OFFER"
                        data={test.features}
                    />
                )}
            </Section>

            {/* Start Appointment Section */}
            {/* <Section
                topMd={190}
                topLg={145}
                topXl={105}
                bottomMd={190}
                bottomLg={145}
                bottomXl={110}
                id="appointment"
            >
                <AppointmentSection
                    sectionTitle="Appointment"
                    sectionTitleUp="BOOK AN"
                    imgUrl="/images/home_1/appointment.jpeg"
                />
            </Section> */}
            {/* End Appointment Section */}
            <br />
            {/* <Section className="cs_footer_margin_0">
                <BannerSectionStyle7
                    imgUrl="/images/departments/banner_img_3.png"
                    bgUrl="/images/departments/banner_bg_3.svg"
                    title="Don't Let Your Health <br />Take a Backseat!"
                    subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
                />
            </Section> */}
        </>
    );
}
